import { TemplateKeyModal } from './TemplateKeyModal';

type TemplateDuplicateModalProps = {
  /** 모달 열림 여부. false면 렌더 안 함. */
  open: boolean;
  /** 원본(현재 로드된) 템플릿 key — 표시 + 기본 새 key 생성(`${sourceKey}-copy`)에 사용. */
  sourceKey: string;
  /** 원본 템플릿 이름 — 표시 + 자동 생성 이름 안내('{sourceName} (복제)')에 사용. */
  sourceName: string;
  /** 미저장 변경 여부 — true면 "저장본 기준" 경고를 warning으로 노출. */
  isDirty: boolean;
  /** 이미 존재하는 template key 목록 — 중복 key 인라인 검증에 사용. */
  existingKeys: string[];
  /** 복제 요청 진행 중 — 확인 버튼 비활성(중복 클릭 방지). */
  busy: boolean;
  /** 확인 — 검증 통과한 새 key를 전달. 이름은 호출부가 자동 생성한다. */
  onConfirm: (newKey: string) => void;
  onClose: () => void;
};

/**
 * 템플릿 복제 — key 전용 입력 모달. TemplateKeyModal 위의 얇은 래퍼(오버레이·z-index·닫기·검증·busy는 KeyModal 공용).
 * - 이름은 묻지 않는다: 서버 DTO는 name 필수라 호출부가 '{sourceName} (복제)'로 자동 전송하고,
 *   운영자는 로드 후 속성 패널에서 바로 수정한다(topSlot 안내).
 * - 기본 key = `${sourceKey}-copy`, 힌트 예시도 동일. key는 kebab-case + 빈값/중복 시 확인 비활성(KeyModal).
 * - 복제는 서버 저장본 기준 → 미저장 변경(isDirty)이면 warning으로 강조(amber). onConfirm은 검증 통과 key 전달.
 */
export function TemplateDuplicateModal({
  open,
  sourceKey,
  sourceName,
  isDirty,
  existingKeys,
  busy,
  onConfirm,
  onClose,
}: TemplateDuplicateModalProps) {
  return (
    <TemplateKeyModal
      open={open}
      title="템플릿 복제"
      confirmLabel="복제"
      keyLabel="복제본 key"
      defaultKey={`${sourceKey}-copy`}
      hintExample={`${sourceKey}-copy`}
      existingKeys={existingKeys}
      busy={busy}
      warning={
        isDirty
          ? '복제는 서버에 저장된 상태 기준입니다 — 저장하지 않은 변경은 포함되지 않습니다.'
          : undefined
      }
      topSlot={
        <>
          <p className="text-sm text-gray-600">
            원본: <span className="font-medium text-gray-800">{sourceName}</span>{' '}
            <span className="text-gray-400">({sourceKey})</span>
          </p>
          <p className="text-xs leading-relaxed text-gray-500">
            이름은 '{sourceName} (복제)'로 생성되며 속성에서 바로 수정할 수 있습니다.
          </p>
        </>
      }
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
}
